import vm from '@/main.js'
import * as HelperModel from '@/models/transaction.js'

class TransactionHelpers {
    itemTypes() {
        const types = vm.$i18n.messages[vm.$i18n.locale]["$vuetify"][
            "transaction_types"
        ];
        var res = [];
        for (var t in types) {
            res.push({
                name: types[t],
                key: t
            });
        }
        return res
    }

    newItemModel() {
        return JSON.parse(JSON.stringify(HelperModel.newItem))
    }

    validatorModel() {
        return JSON.parse(JSON.stringify(HelperModel.validator))
    }

    paymentDate(value) {
        let date = value;
        if (!(value instanceof Date)) {
            if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}(?:$|[T ])/.test(value)) {
                return null;
            }
            const datePart = value.slice(0, 10);
            date = new Date(datePart + 'T00:00:00');
            if (Number.isNaN(date.getTime()) || this.paymentDate(date) !== datePart) {
                return null;
            }
        }
        if (Number.isNaN(date.getTime())) return null;

        return [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'),
            String(date.getDate()).padStart(2, '0')].join('-');
    }

    paymentPayload(filled, companyId) {
        const membership = filled.payment_type === 'membership';
        return {
            company_id: companyId,
            payment_type: filled.payment_type,
            amount: Number(filled.amount),
            payed_from: membership ? this.paymentDate(filled.payed_from) : null,
            payed_to: membership ? this.paymentDate(filled.payed_to) : null,
            next_payment_amount: membership ? Number(filled.next_payment_amount) : null,
            barcode_count: membership ? null : Number(filled.barcode_count),
            note: filled.note || null
        };
    }

    validateForm(filled) {
        const validator = this.validatorModel();
        validator.hasError = false;
        const invalid = (field, message) => {
            validator[field].error_show = true;
            validator[field].error_msg = vm.$vuetify.lang.t('$vuetify.errors.' + message);
            validator.hasError = true;
        };

        if (!Number.isFinite(Number(filled.amount)) || Number(filled.amount) <= 0) {
            invalid('amount', 'invalid_amount');
        }
        if (!['membership', 'barcode'].includes(filled.payment_type)) {
            invalid('payment_type', 'invalid_transaction_type');
        }

        if (filled.payment_type === 'membership') {
            const from = this.paymentDate(filled.payed_from);
            const to = this.paymentDate(filled.payed_to);
            if (!from) invalid('payed_from', filled.payed_from ? 'real_info' : 'date_required');
            if (!to) invalid('payed_to', filled.payed_to ? 'real_info' : 'date_required');
            if (from && to && from > to) invalid('payed_to', 'real_info');

            const nextAmount = filled.next_payment_amount;
            if (nextAmount === null || nextAmount === undefined || String(nextAmount).trim() === '' ||
                !Number.isFinite(Number(nextAmount)) || Number(nextAmount) < 0) {
                invalid('next_payment_amount', 'invalid_amount');
            }
        }

        if (filled.payment_type === 'barcode' &&
            (!Number.isSafeInteger(Number(filled.barcode_count)) || Number(filled.barcode_count) <= 0)) {
            invalid('barcode_count', 'real_info');
        }

        return validator;
    }
}

const TransactionHelper = new TransactionHelpers
export default TransactionHelper
